// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.conversation.SatelliteWebLandlordConversationHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebLandlordConversationHandler_addMessage,
  SatelliteWebLandlordConversationHandler_addSystemMessage,
  SatelliteWebLandlordConversationHandler_archiveConversation,
  SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing,
  SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing_Path,
  SatelliteWebLandlordConversationHandler_getAttachmentsMetadata,
  SatelliteWebLandlordConversationHandler_getAttachmentsMetadata_Path,
  SatelliteWebLandlordConversationHandler_getCachedConversationCounts,
  SatelliteWebLandlordConversationHandler_getCachedConversationCounts_Path,
  SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId,
  SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId_Path,
  SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage,
  SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage_Path,
  SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox,
  SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox_Path,
  SatelliteWebLandlordConversationHandler_getMessages,
  SatelliteWebLandlordConversationHandler_getMessages_Path,
  SatelliteWebLandlordConversationHandler_markConversationAsRead,
  SatelliteWebLandlordConversationHandler_markConversationAsUnread,
  SatelliteWebLandlordConversationHandler_reportConversation,
  SatelliteWebLandlordConversationHandler_search,
  SatelliteWebLandlordConversationHandler_search_Path,
  SatelliteWebLandlordConversationHandler_unarchiveConversation,
  SatelliteWebLandlordConversationHandler_updateConversationAttributes,
  SatelliteWebLandlordConversationHandler_updateTourScheduledTime,
} from '@zg-rentals/ts-satellite-client';

import type {
  ExportExcelLeadsForListingRequestDto,
  SatelliteWebLandlordAddSystemMessageRequestDto,
  SatelliteWebLandlordAddSystemMessageResponseDto,
  SatelliteWebLandlordArchiveConversationRequestDto,
  SatelliteWebLandlordConversationAddMessageRequestDto,
  SatelliteWebLandlordConversationAddMessageResponseDto,
  SatelliteWebLandlordConversationGetMessagesRequestDto,
  SatelliteWebLandlordConversationGetMessagesResponseDto,
  SatelliteWebLandlordConversationSearchRequestDto,
  SatelliteWebLandlordConversationSearchResponseDto,
  SatelliteWebLandlordGetAttachmentsMetadataRequestDto,
  SatelliteWebLandlordGetAttachmentsMetadataResponseDto,
  SatelliteWebLandlordGetCachedConversationCountsResponseDto,
  SatelliteWebLandlordGetConversationInformationByInquiryIdRequestDto,
  SatelliteWebLandlordGetConversationInformationByInquiryIdResponseDto,
  SatelliteWebLandlordGetLatestConversationsForInboxRequestDto,
  SatelliteWebLandlordGetLatestConversationsForInboxResponseDto,
  SatelliteWebLandlordGetLatestForContactsPageRequestDto,
  SatelliteWebLandlordGetLatestForContactsPageResponseDto,
  SatelliteWebLandlordMarkConversationAsReadRequestDto,
  SatelliteWebLandlordMarkConversationAsUnreadRequestDto,
  SatelliteWebLandlordReportConversationRequestDto,
  SatelliteWebLandlordUnarchiveConversationRequestDto,
  SatelliteWebLandlordUpdateConversationAttributesRequestDto,
  SatelliteWebLandlordUpdateTourScheduledTimeRequestDto,
} from '@zg-rentals/ts-satellite-client';

export interface SatelliteWebLandlordConversationHandler_addMessage_Args {
  postData: SatelliteWebLandlordConversationAddMessageRequestDto;
}

export type SatelliteWebLandlordConversationHandler_addMessage_Options = UseMutationOptions<
  SatelliteWebLandlordConversationAddMessageResponseDto,
  unknown,
  SatelliteWebLandlordConversationHandler_addMessage_Args
>;

/**
 * Add a message to a conversation
 */
export const useSatelliteWebLandlordConversationHandler_addMessage = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordConversationHandler_addMessage_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordConversationHandler_addMessage_Args) =>
      SatelliteWebLandlordConversationHandler_addMessage(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordConversationHandler_addSystemMessage_Args {
  postData: SatelliteWebLandlordAddSystemMessageRequestDto;
}

export type SatelliteWebLandlordConversationHandler_addSystemMessage_Options = UseMutationOptions<
  SatelliteWebLandlordAddSystemMessageResponseDto,
  unknown,
  SatelliteWebLandlordConversationHandler_addSystemMessage_Args
>;

/**
 * Add a predefined system message to a conversation
 */
export const useSatelliteWebLandlordConversationHandler_addSystemMessage = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordConversationHandler_addSystemMessage_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordConversationHandler_addSystemMessage_Args) =>
      SatelliteWebLandlordConversationHandler_addSystemMessage(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordConversationHandler_archiveConversation_Args {
  postData: SatelliteWebLandlordArchiveConversationRequestDto;
}

export type SatelliteWebLandlordConversationHandler_archiveConversation_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordConversationHandler_archiveConversation_Args
>;

/**
 * Archive a conversation
 */
export const useSatelliteWebLandlordConversationHandler_archiveConversation = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordConversationHandler_archiveConversation_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordConversationHandler_archiveConversation_Args) =>
      SatelliteWebLandlordConversationHandler_archiveConversation(args.postData, httpClient),
  });
};

export type SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing_Options = UseQueryOptions<
  void,
  unknown,
  void,
  readonly [string, ExportExcelLeadsForListingRequestDto]
>;

const SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing_GetKey = (
  postData: ExportExcelLeadsForListingRequestDto,
) => [SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing_Path, postData] as const;

export const SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing_queryOptions = (
  postData: ExportExcelLeadsForListingRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing_GetKey(postData),
    queryFn: () => SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Export leads for a listing in Excel
 */
export const useSatelliteWebLandlordConversationHandler_exportExcelLeadsForListing = (
  postData: ExportExcelLeadsForListingRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordConversationHandler_exportExcelLeadsForListing.getKey =
  SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing_GetKey;

export type SatelliteWebLandlordConversationHandler_getAttachmentsMetadata_Options = UseQueryOptions<
  SatelliteWebLandlordGetAttachmentsMetadataResponseDto,
  unknown,
  SatelliteWebLandlordGetAttachmentsMetadataResponseDto,
  readonly [string, SatelliteWebLandlordGetAttachmentsMetadataRequestDto]
>;

const SatelliteWebLandlordConversationHandler_getAttachmentsMetadata_GetKey = (
  postData: SatelliteWebLandlordGetAttachmentsMetadataRequestDto,
) => [SatelliteWebLandlordConversationHandler_getAttachmentsMetadata_Path, postData] as const;

export const SatelliteWebLandlordConversationHandler_getAttachmentsMetadata_queryOptions = (
  postData: SatelliteWebLandlordGetAttachmentsMetadataRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordConversationHandler_getAttachmentsMetadata_GetKey(postData),
    queryFn: () => SatelliteWebLandlordConversationHandler_getAttachmentsMetadata(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get all attachments' metadata for a conversation
 */
export const useSatelliteWebLandlordConversationHandler_getAttachmentsMetadata = (
  postData: SatelliteWebLandlordGetAttachmentsMetadataRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordConversationHandler_getAttachmentsMetadata_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordConversationHandler_getAttachmentsMetadata_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordConversationHandler_getAttachmentsMetadata.getKey =
  SatelliteWebLandlordConversationHandler_getAttachmentsMetadata_GetKey;

export type SatelliteWebLandlordConversationHandler_getCachedConversationCounts_Options = UseQueryOptions<
  SatelliteWebLandlordGetCachedConversationCountsResponseDto,
  unknown,
  SatelliteWebLandlordGetCachedConversationCountsResponseDto,
  readonly [string]
>;

const SatelliteWebLandlordConversationHandler_getCachedConversationCounts_GetKey = () =>
  [SatelliteWebLandlordConversationHandler_getCachedConversationCounts_Path] as const;

export const SatelliteWebLandlordConversationHandler_getCachedConversationCounts_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordConversationHandler_getCachedConversationCounts_GetKey(),
    queryFn: () => SatelliteWebLandlordConversationHandler_getCachedConversationCounts(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get cached conversation counts from the last 90 days
 */
export const useSatelliteWebLandlordConversationHandler_getCachedConversationCounts = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordConversationHandler_getCachedConversationCounts_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...SatelliteWebLandlordConversationHandler_getCachedConversationCounts_queryOptions({ httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordConversationHandler_getCachedConversationCounts.getKey =
  SatelliteWebLandlordConversationHandler_getCachedConversationCounts_GetKey;

export type SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId_Options = UseQueryOptions<
  SatelliteWebLandlordGetConversationInformationByInquiryIdResponseDto,
  unknown,
  SatelliteWebLandlordGetConversationInformationByInquiryIdResponseDto,
  readonly [string, SatelliteWebLandlordGetConversationInformationByInquiryIdRequestDto]
>;

const SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId_GetKey = (
  postData: SatelliteWebLandlordGetConversationInformationByInquiryIdRequestDto,
) => [SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId_Path, postData] as const;

export const SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId_queryOptions = (
  postData: SatelliteWebLandlordGetConversationInformationByInquiryIdRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId_GetKey(postData),
    queryFn: () => SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get conversation information by inquiry Id
 */
export const useSatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId = (
  postData: SatelliteWebLandlordGetConversationInformationByInquiryIdRequestDto,
  {
    httpClient,
    ...options
  }: Omit<
    SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId_queryOptions(postData, {
      httpClient,
    }),
    ...options,
  });
};
useSatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId.getKey =
  SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId_GetKey;

export type SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage_Options = UseQueryOptions<
  SatelliteWebLandlordGetLatestForContactsPageResponseDto,
  unknown,
  SatelliteWebLandlordGetLatestForContactsPageResponseDto,
  readonly [string, SatelliteWebLandlordGetLatestForContactsPageRequestDto]
>;

const SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage_GetKey = (
  postData: SatelliteWebLandlordGetLatestForContactsPageRequestDto,
) => [SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage_Path, postData] as const;

export const SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage_queryOptions = (
  postData: SatelliteWebLandlordGetLatestForContactsPageRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage_GetKey(postData),
    queryFn: () => SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get a landlord's most recently updated conversations for the Contacts Page only. Each conversation will include one message for that conversation. If the entire conversation consists of nothing but system messages, then the message included will be the most recent system message, otherwise the message included will be the most recent user message even if the most recent message is actually a system message. That is, system messages will only be returned if the entire conversation is composed solely of system messages.
 */
export const useSatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage = (
  postData: SatelliteWebLandlordGetLatestForContactsPageRequestDto,
  {
    httpClient,
    ...options
  }: Omit<
    SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage_queryOptions(postData, {
      httpClient,
    }),
    ...options,
  });
};
useSatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage.getKey =
  SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage_GetKey;

export type SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox_Options = UseQueryOptions<
  SatelliteWebLandlordGetLatestConversationsForInboxResponseDto,
  unknown,
  SatelliteWebLandlordGetLatestConversationsForInboxResponseDto,
  readonly [string, SatelliteWebLandlordGetLatestConversationsForInboxRequestDto]
>;

const SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox_GetKey = (
  postData: SatelliteWebLandlordGetLatestConversationsForInboxRequestDto,
) => [SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox_Path, postData] as const;

export const SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox_queryOptions = (
  postData: SatelliteWebLandlordGetLatestConversationsForInboxRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox_GetKey(postData),
    queryFn: () => SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get a landlord's most recently updated conversations for the Inbox page only. Each conversation will include one message for that conversation. If the entire conversation consists of nothing but system messages, then the message included will be the most recent system message, otherwise the message included will be the most recent user message even if the most recent message is actually a system message. That is, system messages will only be returned if the entire conversation is composed solely of system messages.
 */
export const useSatelliteWebLandlordConversationHandler_getLatestConversationsForInbox = (
  postData: SatelliteWebLandlordGetLatestConversationsForInboxRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordConversationHandler_getLatestConversationsForInbox.getKey =
  SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox_GetKey;

export type SatelliteWebLandlordConversationHandler_getMessages_Options = UseQueryOptions<
  SatelliteWebLandlordConversationGetMessagesResponseDto,
  unknown,
  SatelliteWebLandlordConversationGetMessagesResponseDto,
  readonly [string, SatelliteWebLandlordConversationGetMessagesRequestDto]
>;

const SatelliteWebLandlordConversationHandler_getMessages_GetKey = (
  postData: SatelliteWebLandlordConversationGetMessagesRequestDto,
) => [SatelliteWebLandlordConversationHandler_getMessages_Path, postData] as const;

export const SatelliteWebLandlordConversationHandler_getMessages_queryOptions = (
  postData: SatelliteWebLandlordConversationGetMessagesRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordConversationHandler_getMessages_GetKey(postData),
    queryFn: () => SatelliteWebLandlordConversationHandler_getMessages(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get messages for a conversation
 */
export const useSatelliteWebLandlordConversationHandler_getMessages = (
  postData: SatelliteWebLandlordConversationGetMessagesRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordConversationHandler_getMessages_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordConversationHandler_getMessages_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordConversationHandler_getMessages.getKey =
  SatelliteWebLandlordConversationHandler_getMessages_GetKey;

export interface SatelliteWebLandlordConversationHandler_markConversationAsRead_Args {
  postData: SatelliteWebLandlordMarkConversationAsReadRequestDto;
}

export type SatelliteWebLandlordConversationHandler_markConversationAsRead_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordConversationHandler_markConversationAsRead_Args
>;

/**
 * Mark a conversation as read
 */
export const useSatelliteWebLandlordConversationHandler_markConversationAsRead = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordConversationHandler_markConversationAsRead_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordConversationHandler_markConversationAsRead_Args) =>
      SatelliteWebLandlordConversationHandler_markConversationAsRead(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordConversationHandler_markConversationAsUnread_Args {
  postData: SatelliteWebLandlordMarkConversationAsUnreadRequestDto;
}

export type SatelliteWebLandlordConversationHandler_markConversationAsUnread_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordConversationHandler_markConversationAsUnread_Args
>;

/**
 * Mark a conversation as unread
 */
export const useSatelliteWebLandlordConversationHandler_markConversationAsUnread = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordConversationHandler_markConversationAsUnread_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordConversationHandler_markConversationAsUnread_Args) =>
      SatelliteWebLandlordConversationHandler_markConversationAsUnread(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordConversationHandler_reportConversation_Args {
  postData: SatelliteWebLandlordReportConversationRequestDto;
}

export type SatelliteWebLandlordConversationHandler_reportConversation_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordConversationHandler_reportConversation_Args
>;

/**
 * Report a conversation. This will always mark the conversation as read by the reporting user, and depending on the reason provided, could also mark the conversation as spam.
 */
export const useSatelliteWebLandlordConversationHandler_reportConversation = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordConversationHandler_reportConversation_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordConversationHandler_reportConversation_Args) =>
      SatelliteWebLandlordConversationHandler_reportConversation(args.postData, httpClient),
  });
};

export type SatelliteWebLandlordConversationHandler_search_Options = UseQueryOptions<
  SatelliteWebLandlordConversationSearchResponseDto,
  unknown,
  SatelliteWebLandlordConversationSearchResponseDto,
  readonly [string, SatelliteWebLandlordConversationSearchRequestDto]
>;

const SatelliteWebLandlordConversationHandler_search_GetKey = (
  postData: SatelliteWebLandlordConversationSearchRequestDto,
) => [SatelliteWebLandlordConversationHandler_search_Path, postData] as const;

export const SatelliteWebLandlordConversationHandler_search_queryOptions = (
  postData: SatelliteWebLandlordConversationSearchRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordConversationHandler_search_GetKey(postData),
    queryFn: () => SatelliteWebLandlordConversationHandler_search(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Search conversations for partial or full matching renter names or renter phone numbers
 */
export const useSatelliteWebLandlordConversationHandler_search = (
  postData: SatelliteWebLandlordConversationSearchRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordConversationHandler_search_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordConversationHandler_search_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordConversationHandler_search.getKey = SatelliteWebLandlordConversationHandler_search_GetKey;

export interface SatelliteWebLandlordConversationHandler_unarchiveConversation_Args {
  postData: SatelliteWebLandlordUnarchiveConversationRequestDto;
}

export type SatelliteWebLandlordConversationHandler_unarchiveConversation_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordConversationHandler_unarchiveConversation_Args
>;

/**
 * Unarchive a conversation
 */
export const useSatelliteWebLandlordConversationHandler_unarchiveConversation = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordConversationHandler_unarchiveConversation_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordConversationHandler_unarchiveConversation_Args) =>
      SatelliteWebLandlordConversationHandler_unarchiveConversation(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordConversationHandler_updateConversationAttributes_Args {
  postData: SatelliteWebLandlordUpdateConversationAttributesRequestDto;
}

export type SatelliteWebLandlordConversationHandler_updateConversationAttributes_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordConversationHandler_updateConversationAttributes_Args
>;

/**
 * Update conversation attributes
 */
export const useSatelliteWebLandlordConversationHandler_updateConversationAttributes = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordConversationHandler_updateConversationAttributes_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordConversationHandler_updateConversationAttributes_Args) =>
      SatelliteWebLandlordConversationHandler_updateConversationAttributes(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordConversationHandler_updateTourScheduledTime_Args {
  postData: SatelliteWebLandlordUpdateTourScheduledTimeRequestDto;
}

export type SatelliteWebLandlordConversationHandler_updateTourScheduledTime_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordConversationHandler_updateTourScheduledTime_Args
>;

/**
 * Update the note for this conversation's scheduled tour time. This is only viewable by the landlord and is provided solely for her convenience: it is not an end-to-end touring solution. This tour schedule is the original satellite tour scheduling unrelated to ZRM Tours.
 */
export const useSatelliteWebLandlordConversationHandler_updateTourScheduledTime = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordConversationHandler_updateTourScheduledTime_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordConversationHandler_updateTourScheduledTime_Args) =>
      SatelliteWebLandlordConversationHandler_updateTourScheduledTime(args.postData, httpClient),
  });
};
